export const looksLikeHtmlDocument = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false
  }
  const trimmed = value.trimStart().toLowerCase()
  return trimmed.startsWith('<!doctype html') || trimmed.startsWith('<html')
}

const OPENING_TAG = /^<([a-z][a-z0-9-]*)(\s[^>]*)?>/i

export const looksLikeHtmlFragment = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false
  }
  const trimmed = value.trim()
  const opening = OPENING_TAG.exec(trimmed)
  if (opening === null) {
    return false
  }
  const tag = opening[1].toLowerCase()
  return trimmed.toLowerCase().includes(`</${tag}>`)
}
